export default __webpack_public_path__ + "static/media/ipv_demo.0060e923.jpg";